<template>
  <a-modal v-model="showModal" class="filterModalContainer mobile-modal-fullscreen" :closable="false">
    <div class="d-flex align-items-center">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
      <h4 class="fw700 font24 gray700 mb-0">Filter Posts</h4>
      <button class="fw700 btn font-white p1224 font14 br6 show-in-mobile ml-auto" @click="handleApply()" :style="{ background: getPrimaryColor() }">Submit</button>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto font20 cp" @click="hide" />
    </div>
    <h6 class="mt-5 fw700 gray500 font16">Posts from</h6>
    <div class="d-flex flex-column">
      <a-radio-group v-model="selectedFrom" class="d-flex flex-column gap24 gray900">
        <a-radio :value="''">All</a-radio>
        <a-radio :value="'my_circle_members'">My Circle Members</a-radio>
        <a-radio :value="'healthcare_professional'">Healthcare Professionals </a-radio>
        <a-radio :value="'admin'">DoveMed Admins</a-radio>
      </a-radio-group>
    </div>
    <h6 class="mt-5 fw700 gray500 font16">Post type</h6>
    <a-radio-group v-model="selectedType" class="d-flex flex-column gap24 gray900">
      <a-radio :value="'post'">Post</a-radio>
      <a-radio :value="'question'">Question</a-radio>
      <a-radio :value="'poll'">Poll</a-radio>
      <a-radio :value="'job'">Job</a-radio>
      <a-radio :value="'event'">Event</a-radio>
      <a-radio :value="'press'">Press Release</a-radio>
      <a-radio :value="'only_with_images'">Only with Images</a-radio>
    </a-radio-group>
    <template #footer>
      <button class="fw700 btn font14 bg-gray200 p1224 gray600 br6" @click="handleCancel()">Clear Filters</button>
      <a-button class="fw700 btn font-white p1224 font14 br6 hide-in-mobile" @click="handleApply()" :style="{ background: getPrimaryColor() }"> Apply Filters </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "PostFiltersModal",
  props: {
    handleAnswer: Function,
  },
  data() {
    return {
      selectedType: "",
      selectedFrom: "",
      showModal: false,
    }
  },
  methods: {
    show() {
      this.showModal = true
      this.selectedType = this.$route.params.type
    },
    hide() {
      this.selectedType = ""
      this.selectedFrom = ""
      this.showModal = false
    },
    handleCancel() {
      this.showModal = false
      this.selectedType = ""
      this.selectedFrom = ""
      this.handleAnswer("")
    },
    handleApply() {
      this.showModal = false
      this.$route.params.type = this.selectedType || ""
      this.handleAnswer(this.selectedFrom === "" ? this.selectedType : this.selectedFrom + "," + (this.selectedType || ""))
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-modal-content {
  border-radius: 8px !important;
}
.btn {
  border: none !important;
}
@media screen and (max-width: 600px) {
  .justify-content-between {
    gap: 24px;
    flex-direction: column;
  }
  .bg-gray200 {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/PostFilters.vue